import { Injectable } from '@angular/core';
import { Events, LoadingController, Platform } from 'ionic-angular';
import { Globals } from '../../globals';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import * as firebase from 'firebase';

@Injectable()
export class EmailServices {

  public firestore;

  constructor(public events: Events,
    public loadingCtrl: LoadingController,
    public platform: Platform,
    public translate: TranslateService,
    public globals: Globals,
    public http: HttpClient) {
    this.firestore = firebase.firestore();
  }

  async sendEmailReservation(type, reservation) {
    //get logo restaurant
    var logo = '';
    if (this.globals.restaurant.logo) {
      logo = this.getImageUrl(this.globals.restaurant.logo);
    }

    let _email = {
      'UID_RESTAURANT': this.globals.restaurant_uid,
      'type': type,
      'customer_name': reservation.name,
      'customer_email': reservation.email,
      'customer_phone': reservation.phone,
      'restaurant_logo': logo,
      'restaurant_company': this.globals.restaurant.company,
      'restaurant_address': this.globals.restaurant.address,
      'restaurant_email': this.globals.restaurant.email,
      'restaurant_phone': this.globals.restaurant.phone,
      'restaurant_lang': this.globals.restaurant.lang,
      'comment': reservation.message,
      'date': reservation.date,
      'hour': reservation.hour,
      'persons': reservation.adults,
      'public_key': this.globals.ifVarEmpty(this.globals.public_key),
      'uid_reservation': this.globals.ifVarEmpty(reservation.UID),
      'reservation_text_web': this.globals.ifVarEmpty(this.globals.restaurant.reservation_text_web),
      'restaurant_domain': this.globals.ifVarEmpty(this.globals.domini_sites),
      'reason': this.globals.ifVarEmpty(reservation.reason)
    }
    this.firestore.collection('_emails').add(_email);
  }


  getImageUrl(img_url) {
    if (img_url != "" && img_url != void 0) {
      img_url = "https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/" + img_url.replace("logo/", "logo%2F") + "?alt=media";
      return img_url;
    } else {
      return "";
    }
  }


}



// WEBPACK FOOTER //
// ./src/pages/services/emailServices.ts